'use strict';

/* global $ */
/* global _ */
/* global Backbone */
/* global Marionette */

// import * as InputCheck from '../../utils/input_check';

// import toPrice from '../../utils/price';

import { ProductModel, ProductCollection } from './core/models';
import { Product } from './core/views';


class Products {
    init(options){
        let self = this;

        let opt = _.merge({ }, {
            product: '.js-product',
            product_count: '.js-product-count',
            product_buy: '.js-product-buy',
            product_summ: '.js-product-summ',
            product_delete: '.js-product-delete',
        }, options);

        let $products = $(opt.product);

        if($products.length > 0) {
            if(!self.products) {
                self.products = new ProductCollection();
            }

            let i = 0;
            while(i < $products.length){
                let product = new ProductModel();

                new Product({
                    model: product,
                    el: $products.eq(i),
                    buy: opt.product_buy,
                    count: opt.product_count,
                    summ: opt.product_summ,
                    delete: opt.product_delete
                });

                self.products.add(product);
                i++;
            }
        }
    }
    clear(){
        let self = this;
        if(self.products){
            self.products.reset();
        }
    }
}

export { Products };
